import type { TOC } from '@ember/component/template-only';
import BaseSummary from 'parog-web/components/mici/base-summary';
import type Patient from 'parog-web/models/patient';
interface Signature {
  Args: {
    patient: Patient;
  };
}

export default <template>
  <BaseSummary
    @patient={{@patient}}
    @title='Historique des questionnaires RCH'
    @feature='mici'
    @component='rch-survey-consult-form'
    @modelName='rch-survey-filled-journal-event'
  />
</template> satisfies TOC<Signature>;
